import { get } from 'lodash';

export const buildPolicyListTitle = (policyList) => {
  const policyNames = policyList.map((item) =>
    get(item, ['policy', 'currentVersion', 'name'], '(policy deleted)'),
  );
  return policyNames.join(', ');
};

export enum actOptions {
  now = 'now',
  schedule = 'schedule',
}

export enum policyAction {
  activate = 'activate',
  reorder = 'reorder',
}

export enum scheduleViewTabs {
  list = 'list',
  calender = 'calender',
}

export enum scheduleStatus {
  pending = 'pending',
  queued = 'queued',
  partial = 'partial',
  error = 'error',
  success = 'success',
  discarded = 'discarded',
}

export const messageMap = {
  [scheduleStatus.error]: {
    level: 'error',
    text: 'Failed to activate policies.',
    backgroundColor: '#ffa39e',
  },
  [scheduleStatus.partial]: {
    level: 'warning',
    text: 'Partial success. Please retry failed updates.',
    backgroundColor: '#ffe58f',
  },
  [scheduleStatus.success]: {
    level: 'success',
    text: 'Policies activated successfully.',
    backgroundColor: '#52c41a',
    duration: 4,
  },
  [scheduleStatus.pending]: {
    level: 'info',
    text: 'Policies scheduled successfully.',
    backgroundColor: '#91d5ff',
  },
};

const getPolicyStr = (list, lookup) =>
  list.map((pid) => get(lookup, [pid, 'name'], '(policy deleted)')).join(', ');

export const genSummaryText = (policyLookup, log) => {
  const description: any = [];
  const { successList, errorList, error, status } = log;

  // description.push(get(messageMap, [status, 'text'], ''));

  switch (status) {
    case scheduleStatus.success: {
      description.push(getPolicyStr(successList, policyLookup));
      break;
    }
    case scheduleStatus.partial: {
      description.push('Succeded: ' + getPolicyStr(successList, policyLookup));
      description.push('Failed: ' + getPolicyStr(errorList, policyLookup));
      break;
    }
    case scheduleStatus.error: {
      description.push(error);
      break;
    }
  }

  return description;
};
